import styles from './container.module.scss';

const Container = (props: React.PropsWithChildren) => (
  <div className={styles['content']}>{props.children}</div>
);

export default Container;
